import React, { useState, useContext } from 'react';
import LinkedMenu from './LinkedMenu';
import ChooseBackgroundDialog from './ChooseBackgroundDialog';
import { TabStateContext } from '../providers/TabProvider';
import { HistoryDispatchContext } from '../providers/HistoryProvider';

export default function CustomizeButton() {
  const [showMenu, setShowMenu] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const { activeTab } = useContext(TabStateContext);
  const dispatch = useContext(HistoryDispatchContext);

  const handleClickOutside = () => {
    setShowMenu(false);
  }

  const handleClick = (e) => {
    setShowMenu(true);
    e.preventDefault();
  }

  const cancelDialog = (e) => {
    setShowDialog(false);
  }

  const doneDialog = (selectedBg) => {
    setShowDialog(false);
    dispatch({
      type: 'changeBackground',
      activeTab,
      bgClass: selectedBg
    });
  }

  const handleMenuItemClick = (params) => {
    switch (params.itemIndex) {
      case 1: {
        setShowDialog(true);
        break;
      }
      default: {
        break;
      }
    }
  }

  return (
    <>
      <ChooseBackgroundDialog
        showDialog={showDialog}
        onDone={doneDialog}
        onCancel={cancelDialog}>
      </ChooseBackgroundDialog>
      <LinkedMenu
        className="popup-menu--rounded popup-menu--with-bottom"
        show={showMenu}
        itemType="none"
        onClickOutside={handleClickOutside}
        onMenuItemClick={handleMenuItemClick}
      >
        <div id="edit-bg" onClick={handleClick} tabIndex="0" role="button" className="ep-enhanced">
          <div id="edit-bg-icon" aria-label="Customize this page" title="Customize this page">
          </div>
          <span id="edit-bg-text">Customize</span>
        </div>
        <div className="menu-item__title--top">
          <span className="menu-item__title">Customize this page</span>
        </div>
        <div data-index={1} className="menu-item menu-item--selectable menu-item--fixed-height">
          <div className="bg-option-img bg-option-img--choosebg"></div>
          <span className="menu-item__title">Choose background</span>
        </div>
        <div data-index={2} className="menu-item menu-item--selectable menu-item--fixed-height">
          <div className="bg-option-img bg-option-img--restorebg"></div>
          <span className="menu-item__title">Restore default background</span>
        </div>
      </LinkedMenu>
    </>
  );
}
